export default "__VITE_ASSET__ce37ca0c__"